import bilAPI from "../api";

export const patchTeamPassed = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/olympiad/team_passed/${uuid}/`, body, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
